import { render, staticRenderFns } from "./OptionsBtn.vue?vue&type=template&id=2b950729&scoped=true&"
import script from "./OptionsBtn.vue?vue&type=script&lang=js&"
export * from "./OptionsBtn.vue?vue&type=script&lang=js&"
import style0 from "./OptionsBtn.vue?vue&type=style&index=0&id=2b950729&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b950729",
  null
  
)

export default component.exports